import equalImpl from 'fast-deep-equal';

export const equal = <T>(a: T, b: T): boolean => equalImpl(a, b);
